import React from 'react';
import { Alert, Button } from 'antd';

export const PENDING_MESSAGE = '账户准备中…最多等 30 秒';
export const TIMEOUT_MESSAGE = '网络较慢，请稍后重试';
export const ERROR_MESSAGE = '加载失败，请检查网络后重试';

export const PendingAlert = ({ style }) => (
  <Alert
    type="info"
    showIcon
    message={PENDING_MESSAGE}
    style={style || { marginBottom: 12 }}
  />
);

export const RetryView = ({ message, onRetry, buttonText = '重新加载' }) => (
  <>
    <div style={{ marginBottom: 16, fontSize: 14, color: '#666' }}>{message}</div>
    <Button type="primary" onClick={onRetry} shape="round">{buttonText}</Button>
  </>
);
